declare let google;

let map;
let globalInfoWindow;
let currentGeneratedMarkup;
let currentMarker;

function initMap() {
    map = new google.maps.Map(document.getElementById('hospitalLocationsMap'), {
        mapTypeControl: false,
        streetViewControl: false,
        styles: [
            {
                featureType: 'landscape',
                elementType: 'all',
                stylers: [
                    {
                        color: '#e0e0e0'
                    }
                ]
            },
            {
                featureType: 'poi',
                elementType: 'all',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            },
            {
                featureType: 'road',
                elementType: 'all',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            },
            {
                featureType: 'transit',
                elementType: 'all',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            },
            {
                featureType: 'water',
                elementType: 'all',
                stylers: [
                    {
                        color: '#B2D1ED'
                    },
                    {
                        visibility: 'on'
                    }
                ]
            },
            {
                elementType: 'labels',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            },
            {
                featureType: 'administrative',
                elementType: 'all',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            },
            {
                featureType: 'administrative.country',
                elementType: 'geometry',
                stylers: [
                    {
                        visibility: 'on'
                    }
                ]
            },
            {
                featureType: 'administrative.province',
                elementType: 'geometry',
                stylers: [
                    {
                        visibility: 'on'
                    }
                ]
            }
        ]
    });

    const californiaCoords = [
        { lng: -123.233256, lat: 42.006186 },
        { lng: -122.378853, lat: 42.011663 },
        { lng: -121.037003, lat: 41.995232 },
        { lng: -120.001861, lat: 41.995232 },
        { lng: -119.996384, lat: 40.264519 },
        { lng: -120.001861, lat: 38.999346 },
        { lng: -118.71478, lat: 38.101128 },
        { lng: -117.498899, lat: 37.21934 },
        { lng: -116.540435, lat: 36.501861 },
        { lng: -115.85034, lat: 35.970598 },
        { lng: -114.634459, lat: 35.00118 },
        { lng: -114.634459, lat: 34.87521 },
        { lng: -114.470151, lat: 34.710902 },
        { lng: -114.333228, lat: 34.448009 },
        { lng: -114.136058, lat: 34.305608 },
        { lng: -114.256551, lat: 34.174162 },
        { lng: -114.415382, lat: 34.108438 },
        { lng: -114.535874, lat: 33.933176 },
        { lng: -114.497536, lat: 33.697668 },
        { lng: -114.524921, lat: 33.54979 },
        { lng: -114.727567, lat: 33.40739 },
        { lng: -114.661844, lat: 33.034958 },
        { lng: -114.524921, lat: 33.029481 },
        { lng: -114.470151, lat: 32.843265 },
        { lng: -114.524921, lat: 32.755634 },
        { lng: -114.72209, lat: 32.717295 },
        { lng: -116.04751, lat: 32.624187 },
        { lng: -117.126467, lat: 32.536556 },
        { lng: -117.24696, lat: 32.668003 },
        { lng: -117.252437, lat: 32.876127 },
        { lng: -117.329114, lat: 33.122589 },
        { lng: -117.471515, lat: 33.297851 },
        { lng: -117.7837, lat: 33.538836 },
        { lng: -118.183517, lat: 33.763391 },
        { lng: -118.260194, lat: 33.703145 },
        { lng: -118.413548, lat: 33.741483 },
        { lng: -118.391641, lat: 33.840068 },
        { lng: -118.566903, lat: 34.042715 },
        { lng: -118.802411, lat: 33.998899 },
        { lng: -119.218659, lat: 34.146777 },
        { lng: -119.278905, lat: 34.26727 },
        { lng: -119.558229, lat: 34.415147 },
        { lng: -119.875891, lat: 34.40967 },
        { lng: -120.138784, lat: 34.475393 },
        { lng: -120.472878, lat: 34.448009 },
        { lng: -120.64814, lat: 34.579455 },
        { lng: -120.609801, lat: 34.858779 },
        { lng: -120.670048, lat: 34.902595 },
        { lng: -120.631709, lat: 35.099764 },
        { lng: -120.894602, lat: 35.247642 },
        { lng: -120.905556, lat: 35.450289 },
        { lng: -121.004141, lat: 35.461243 },
        { lng: -121.168449, lat: 35.636505 },
        { lng: -121.283465, lat: 35.674843 },
        { lng: -121.332757, lat: 35.784382 },
        { lng: -121.716143, lat: 36.195153 },
        { lng: -121.896882, lat: 36.315645 },
        { lng: -121.935221, lat: 36.638785 },
        { lng: -121.858544, lat: 36.6114 },
        { lng: -121.787344, lat: 36.803093 },
        { lng: -121.929744, lat: 36.978355 },
        { lng: -122.105006, lat: 36.956447 },
        { lng: -122.335038, lat: 37.115279 },
        { lng: -122.417192, lat: 37.241248 },
        { lng: -122.400761, lat: 37.361741 },
        { lng: -122.515777, lat: 37.520572 },
        { lng: -122.515777, lat: 37.783465 },
        { lng: -122.329561, lat: 37.783465 },
        { lng: -122.406238, lat: 38.15042 },
        { lng: -122.488392, lat: 38.112082 },
        { lng: -122.504823, lat: 37.931343 },
        { lng: -122.701993, lat: 37.893004 },
        { lng: -122.937501, lat: 38.029928 },
        { lng: -122.97584, lat: 38.265436 },
        { lng: -123.129194, lat: 38.451652 },
        { lng: -123.331841, lat: 38.566668 },
        { lng: -123.44138, lat: 38.698114 },
        { lng: -123.737134, lat: 38.95553 },
        { lng: -123.687842, lat: 39.032208 },
        { lng: -123.824765, lat: 39.366301 },
        { lng: -123.764519, lat: 39.552517 },
        { lng: -123.85215, lat: 39.831841 },
        { lng: -124.109566, lat: 40.105688 },
        { lng: -124.361506, lat: 40.259042 },
        { lng: -124.410798, lat: 40.439781 },
        { lng: -124.158859, lat: 40.877937 },
        { lng: -124.109566, lat: 41.025814 },
        { lng: -124.158859, lat: 41.14083 },
        { lng: -124.065751, lat: 41.442061 },
        { lng: -124.147905, lat: 41.715908 },
        { lng: -124.257444, lat: 41.781632 },
        { lng: -124.213628, lat: 42.000709 },
        { lng: -123.233256, lat: 42.006186 }
    ];

    const pennsylvaniaCoords = [
        { lng: -79.76278, lat: 42.252649 },
        { lng: -79.76278, lat: 42.000709 },
        { lng: -75.35932, lat: 42.000709 },
        { lng: -75.249781, lat: 41.863786 },
        { lng: -75.173104, lat: 41.869263 },
        { lng: -75.052611, lat: 41.754247 },
        { lng: -75.074519, lat: 41.60637 },
        { lng: -74.89378, lat: 41.436584 },
        { lng: -74.740426, lat: 41.431108 },
        { lng: -74.69661, lat: 41.359907 },
        { lng: -74.828057, lat: 41.288707 },
        { lng: -74.882826, lat: 41.179168 },
        { lng: -75.134765, lat: 40.971045 },
        { lng: -75.052611, lat: 40.866983 },
        { lng: -75.205966, lat: 40.691721 },
        { lng: -75.195012, lat: 40.576705 },
        { lng: -75.069042, lat: 40.543843 },
        { lng: -75.058088, lat: 40.417874 },
        { lng: -74.773287, lat: 40.215227 },
        { lng: -74.82258, lat: 40.127596 },
        { lng: -75.129289, lat: 39.963288 },
        { lng: -75.145719, lat: 39.88661 },
        { lng: -75.414089, lat: 39.804456 },
        { lng: -75.616736, lat: 39.831841 },
        { lng: -75.786521, lat: 39.722302 },
        { lng: -79.477979, lat: 39.722302 },
        { lng: -80.518598, lat: 39.722302 },
        { lng: -80.518598, lat: 40.636951 },
        { lng: -80.518598, lat: 41.978802 },
        { lng: -80.518598, lat: 41.978802 },
        { lng: -80.332382, lat: 42.033571 },
        { lng: -79.76278, lat: 42.269079 },
        { lng: -79.76278, lat: 42.252649 }
    ];

    const connecticutCoords = [
        { lng: -73.053528, lat: 42.039048 },
        { lng: -71.799309, lat: 42.022617 },
        { lng: -71.799309, lat: 42.006186 },
        { lng: -71.799309, lat: 41.414677 },
        { lng: -71.859555, lat: 41.321569 },
        { lng: -71.947186, lat: 41.338 },
        { lng: -72.385341, lat: 41.261322 },
        { lng: -72.905651, lat: 41.28323 },
        { lng: -73.130205, lat: 41.146307 },
        { lng: -73.371191, lat: 41.102491 },
        { lng: -73.655992, lat: 40.987475 },
        { lng: -73.727192, lat: 41.102491 },
        { lng: -73.48073, lat: 41.21203 },
        { lng: -73.55193, lat: 41.294184 },
        { lng: -73.486206, lat: 42.050002 },
        { lng: -73.053528, lat: 42.039048 }
    ];

    const rhodeIslandPartOneCoords = [
        { lng: -71.196845, lat: 41.67757 },
        { lng: -71.120168, lat: 41.496831 },
        { lng: -71.317338, lat: 41.474923 },
        { lng: -71.196845, lat: 41.67757 }
    ];

    const rhodeIslandPartTwoCoords = [
        { lng: -71.530939, lat: 42.01714 },
        { lng: -71.383061, lat: 42.01714 },
        { lng: -71.328292, lat: 41.781632 },
        { lng: -71.22423, lat: 41.710431 },
        { lng: -71.344723, lat: 41.726862 },
        { lng: -71.448785, lat: 41.578985 },
        { lng: -71.481646, lat: 41.370861 },
        { lng: -71.859555, lat: 41.321569 },
        { lng: -71.799309, lat: 41.414677 },
        { lng: -71.799309, lat: 42.006186 },
        { lng: -71.530939, lat: 42.01714 }
    ];

    const california = new google.maps.Polygon({
        paths: californiaCoords,
        clickable: false,
        strokeColor: '#01519A',
        strokeOpacity: 1,
        strokeWeight: 1.5,
        fillColor: '#01519A',
        fillOpacity: 0.5
    });

    const pennsylvania = new google.maps.Polygon({
        paths: pennsylvaniaCoords,
        clickable: false,
        strokeColor: '#01519A',
        strokeOpacity: 1,
        strokeWeight: 1.5,
        fillColor: '#01519A',
        fillOpacity: 0.5
    });

    const connecticut = new google.maps.Polygon({
        paths: connecticutCoords,
        clickable: false,
        strokeColor: '#01519A',
        strokeOpacity: 1,
        strokeWeight: 1.5,
        fillColor: '#01519A',
        fillOpacity: 0.5
    });

    const rhodeIslandPartOne = new google.maps.Polygon({
        paths: rhodeIslandPartOneCoords,
        clickable: false,
        strokeColor: '#01519A',
        strokeOpacity: 1,
        strokeWeight: 1.5,
        fillColor: '#01519A',
        fillOpacity: 0.5
    });

    const rhodeIslandPartTwo = new google.maps.Polygon({
        paths: rhodeIslandPartTwoCoords,
        clickable: false,
        strokeColor: '#01519A',
        strokeOpacity: 1,
        strokeWeight: 1.5,
        fillColor: '#01519A',
        fillOpacity: 0.5
    });

    california.setMap(map);
    pennsylvania.setMap(map);
    connecticut.setMap(map);
    rhodeIslandPartOne.setMap(map);
    rhodeIslandPartTwo.setMap(map);

    // global infowindow
    globalInfoWindow = new google.maps.InfoWindow();

    generateInfoWindowMarkup(
        34.52,
        -118.38,
        'https://www.crozerhealth.org/globalassets/pmh/map/van-nuys-exterior-cropped.png',
        'Van Nuys Behavioral Health Hospital',
        '818-787-1511',
        '(818) 787-1511',
        '14433 Emelita St, Van Nuys, CA 91401',
        'https://g.page/VanNuysBehavioralHealth?share',
        'https://www.sch-vannuys.com/',
        false
    );

    generateInfoWindowMarkup(
        34.33,
        -118.09,
        'https://www.crozerhealth.org/globalassets/pmh/map/hollywood-exterior-cropped.jpg',
        'Southern California Hospital at Hollywood',
        '323-462-2271',
        '(323) 462-2271',
        '6245 De Longpre Ave, Los Angeles, CA 90028',
        'https://g.page/HospitalinHollywood?share',
        'https://www.sch-hollywood.com/',
        false
    );

    generateInfoWindowMarkup(
        34.16,
        -117.82,
        'https://www.crozerhealth.org/globalassets/pmh/map/los-angeles-exterior-cropped.jpg',
        'Los Angeles Community Hospital',
        '323-267-0477',
        '(323) 267-0477',
        '4081 E. Olympic Blvd, Los Angeles, CA 90023',
        'https://g.page/LosAngelesCommunityHospital?share',
        'https://www.lach-la.com/',
        false
    );

    generateInfoWindowMarkup(
        34.023333463182645,
        -118.39689134424438,
        'https://www.crozerhealth.org/globalassets/pmh/map/culver-city-exterior-cropped.jpg',
        'Southern California Hospital at Culver City',
        '310-836-7000',
        '(310) 836-7000',
        '3828 Delmas Terrace, Culver City, CA 90232',
        'https://g.page/CulverCityHospital?share',
        'https://www.sch-culvercity.com/',
        true
    );

    generateInfoWindowMarkup(
        33.81,
        -118.07,
        'https://www.crozerhealth.org/globalassets/pmh/map/bellflower-exterior-cropped.png',
        'Bellflower Behavioral Health Hospital',
        '562-273-1800',
        '(562) 273-1800',
        '9542 Artesia Blvd, Bellflower, CA 90706',
        'https://g.page/BellflowerBehavioralHealth?share',
        'https://www.lach-bellflower.com/',
        false
    );

    generateInfoWindowMarkup(
        33.95,
        -117.53,
        'https://www.crozerhealth.org/globalassets/pmh/map/norwalk-exterior-cropped.jpg',
        'Norwalk Community Hospital',
        '562-863-4763',
        '(562) 863-4763',
        '13222 Bloomfield Ave, Norwalk, CA 90650',
        'https://g.page/Norwalk-Community-Hospital?share',
        'https://www.lach-norwalk.com/',
        false
    );

    generateInfoWindowMarkup(
        33.63,
        -117.73,
        'https://www.crozerhealth.org/globalassets/pmh/map/foothill-exterior-cropped.jpg',
        'Foothill Regional Medical Center',
        '714-619-7700',
        '(714) 619-7700',
        '14662 Newport Ave, Tustin, CA 92780',
        'https://g.page/FoothillRegionalMedicalCenter?share',
        'https://www.foothillregionalmedicalcenter.com/',
        false
    );

    generateInfoWindowMarkup(
        40.25,
        -75.7,
        'https://www.crozerhealth.org/globalassets/pmh/map/springfield-exterior-cropped.jpg',
        'Springfield Hospital',
        '610-328-8700',
        '(610) 328-8700',
        '190 West Sproul Road, Springfield, PA 19064',
        'https://goo.gl/maps/UErgU6ev1JiCMaLr6',
        'https://www.crozerhealth.org/springfield',
        false
    );

    generateInfoWindowMarkup(
        39.9,
        -75.57,
        'https://www.crozerhealth.org/globalassets/pmh/map/crozer-exterior-cropped.jpg',
        'Crozer-Chester Medical Center',
        '610-447-2000',
        '(610) 447-2000',
        '1 Medical Center Blvd, Upland, PA 19013',
        'https://goo.gl/maps/pWPoBiNiGtUJwFQt7',
        'https://www.crozerhealth.org/crozer',
        false
    );

    generateInfoWindowMarkup(
        40.14,
        -75.2,
        'https://www.crozerhealth.org/globalassets/pmh/map/taylor-exterior-cropped.jpg',
        'Taylor Hospital',
        '610-595-6000',
        '(610) 595-6000',
        '175 East Chester Pike, Ridley Park, PA 19078',
        'https://goo.gl/maps/2cZrptWaQWnqEgev5',
        'https://www.crozerhealth.org/taylor',
        false
    );

    generateInfoWindowMarkup(
        40.45,
        -75.275,
        'https://www.crozerhealth.org/globalassets/pmh/map/delaware-exterior-cropped.jpg',
        'Delaware County Memorial Hospital',
        '610-284-8100',
        '(610) 284-8100',
        '501 N. Lansdowne Ave, Drexel Hill, PA 19026',
        'https://goo.gl/maps/j1U3jt5F8rFv6L729',
        'https://www.crozerhealth.org/dcmh',
        false
    );

    generateInfoWindowMarkup(
        41.55914479158025,
        -73.05984187293801,
        'https://www.crozerhealth.org/globalassets/pmh/map/waterbury-exterior-cropped.jpg',
        'Waterbury Hospital',
        '203-573-6000',
        '(203) 573-6000',
        '64 Robbins St, Waterbury, CT 06708',
        'https://goo.gl/maps/57eDa4P9Y4rnq9rZ8',
        'https://www.waterburyhospital.org/',
        false
    );

    generateInfoWindowMarkup(
        41.63,
        -72.55,
        'https://www.crozerhealth.org/globalassets/pmh/map/manchester-exterior-cropped.jpg',
        'Manchester Memorial Hospital',
        '860-646-1222',
        '(860) 646-1222',
        '71 Haynes St, Manchester, CT 06040',
        'https://goo.gl/maps/kNurXdAXxuRfwVBa8',
        'https://www.echn.org/locations/manchester-memorial-hospital/',
        false
    );

    generateInfoWindowMarkup(
        41.925,
        -72.225,
        'https://www.crozerhealth.org/globalassets/pmh/map/rockville-exterior-cropped.png',
        'Rockville General Hospital',
        '860-872-0501',
        '(860) 872-0501',
        '31 Union St, Vernon, CT 06066',
        'https://goo.gl/maps/GJmLND6vUcAx8Ga49',
        'https://www.echn.org/locations/rockville-general-hospital/',
        false
    );

    generateInfoWindowMarkup(
        41.975,
        -71.575,
        'https://www.crozerhealth.org/globalassets/pmh/map/fatima-exterior-cropped.jpg',
        'Our Lady of Fatima Hospital',
        '401-456-3000',
        '(401) 456-3000',
        '200 High Service Ave, North Providence, RI 02904',
        'https://goo.gl/maps/3zPznKip8ejGsqAE8',
        'https://www.chartercare.org/locations/fatima/',
        false
    );

    generateInfoWindowMarkup(
        41.75,
        -71.45,
        'https://www.crozerhealth.org/globalassets/pmh/map/roger-williams-exterior-cropped.jpg',
        'Roger Williams Medical Center',
        '401-456-2000',
        '(401) 456-2000',
        '825 Chalkstone Ave, Providence, RI 02908',
        'https://goo.gl/maps/EvpXNk6hU9xxNdgz8',
        'https://www.chartercare.org/locations/RWMC/',
        false
    );

    setBounds();
}

function generateInfoWindowMarkup(
    latitude,
    longitude,
    image,
    title,
    formattedPhone,
    phone,
    address,
    googleMapsLink,
    website,
    openByDefault
) {
    let generatedMarkup;

    if (image) {
        generatedMarkup =
            '<div class="map-block-info">' +
            '<div class="img-container">' +
            '<img src="' +
            image +
            '" alt="" />' +
            '</div>' +
            '<div class="title-container">' +
            '<h1 class="title">' +
            title +
            '</h1>' +
            '</div>' +
            '<div class="content-container">' +
            '<p><a href="' +
            googleMapsLink +
            '" target="_blank">' +
            address +
            '</a></p>' +
            '<p><a href="tel:' +
            formattedPhone +
            '">' +
            phone +
            '</a></p>' +
            '<p><a href="' +
            website +
            '" target="_blank">Visit Site</a></p>' +
            '</div>' +
            '</div>';
    } else {
        generatedMarkup =
            '<div class="map-block-info">' +
            '<div class="title-container">' +
            '<h1 class="title">' +
            title +
            '</h1>' +
            '</div>' +
            '<div class="content-container">' +
            '<p><a href="' +
            googleMapsLink +
            '" target="_blank">' +
            address +
            '</a></p>' +
            '<p><a href="tel:' +
            formattedPhone +
            '">' +
            phone +
            '</a></p>' +
            '<p><a href="' +
            website +
            '" target="_blank">Visit Site</a></p>' +
            '</div>' +
            '</div>';
    }

    const svgMarker = {
        path: 'M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0',
        fillColor: '#01315F',
        fillOpacity: 1,
        strokeWeight: 2,
        strokeColor: 'white',
        rotation: 0,
        scale: 0.10625,
        anchor: new google.maps.Point(100, 100)
    };

    const marker = new google.maps.Marker({
        position: { lat: latitude, lng: longitude },
        map,
        icon: svgMarker,
        title: title
    });

    if (openByDefault) {
        currentGeneratedMarkup = generatedMarkup;
        currentMarker = marker;

        globalInfoWindow.setContent(currentGeneratedMarkup);
        globalInfoWindow.open(map, currentMarker);
    }

    marker.addListener('click', () => {
        currentGeneratedMarkup = generatedMarkup;
        currentMarker = marker;

        globalInfoWindow.setContent(generatedMarkup);
        globalInfoWindow.open(map, marker);
    });
}

function setBounds() {
    let bounds = new google.maps.LatLngBounds();

    // Passing northernmost, easternmost, southernmost, and westernmost USA coordinates to fitBounds()
    let myLatLngOne = new google.maps.LatLng(39.942093341297806, -123.39654003609373);
    let myLatLngTwo = new google.maps.LatLng(39.942093341297806, -68.03621376617795);
    let myLatLngThree = new google.maps.LatLng(47.03657754062853, -97.30175006063504);
    let myLatLngFour = new google.maps.LatLng(30.03173625115192, -97.30175006063504);

    bounds.extend(myLatLngOne);
    bounds.extend(myLatLngTwo);
    bounds.extend(myLatLngThree);
    bounds.extend(myLatLngFour);

    map.fitBounds(bounds);

    let infoWindow = globalInfoWindow.getMap();

    // Re-open info window to assure it is still in frame
    if (infoWindow !== null && typeof infoWindow !== 'undefined' && currentGeneratedMarkup !== null && currentMarker !== null) {
        globalInfoWindow.setContent(currentGeneratedMarkup);
        globalInfoWindow.open(map, currentMarker);
    }
}

export default function() {
    (window as any).initMap = initMap;

    // API key is domain restricted
    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCBOeVJrypRAVCQ-V0tcLnKXqFQweyzfeI&callback=window.initMap';
    document.getElementsByTagName('head')[0].appendChild(s);

    window.addEventListener('resize', () => {
        setBounds();
    });
}
